// extracted by mini-css-extract-plugin
export var phone = "_4h-0";
export var phoneDragging = "_4h-1";